import { Signal } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

export function getDmCostElementsFields(
    disabled: boolean,
    translocoContent: Signal<any>
): FormlyFieldConfig[] {
    const prefix = 'systemTables.dmCostElements.';
    if (!translocoContent()) {
        return [];
    }
    return [
        {
            className: 'flex-1',
            type: 'input',
            key: 'chartOfAccounts',
            props: {
                label: translocoContent()[prefix + 'chartOfAccounts'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'glAccount',
            props: {
                label: translocoContent()[prefix + 'glAccount'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'accountGroup',
            props: {
                label: translocoContent()[prefix + 'accountGroup'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'alternativeAccount',
            props: {
                label: translocoContent()[prefix + 'alternativeAccount'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'checkbox',
            key: 'automatic',
            props: {
                label: translocoContent()[prefix + 'automatic'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'costElementCat',
            props: {
                label: translocoContent()[prefix + 'costElementCat'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'costElementGroup',
            props: {
                label: translocoContent()[prefix + 'costElementGroup'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'type',
            props: {
                label: translocoContent()[prefix + 'type'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'asText',
            props: {
                label: translocoContent()[prefix + 'asText'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'costElementGroupText',
            props: {
                label: translocoContent()[prefix + 'costElementGroupText'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1 hidden',
            type: 'input',
            key: 'description',
            props: {
                label: translocoContent()[prefix + 'description'],
                required: false,
                disabled: disabled,
            },
            defaultValue: '',
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'glLText',
            props: {
                label: translocoContent()[prefix + 'glLText'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'glSText',
            props: {
                label: translocoContent()[prefix + 'glSText'],
                required: true,
                disabled: disabled,
            },
        },
    ];
}
